import axios from "axios";
import httpTools from "./httpTools";
import Q from "q";

const Countries = (function () {
    const baseUrl = httpTools.envUrls();
    return {
        get: () => {
            let defer = Q.defer();
            axios
                .get(`${baseUrl}/countries.json`, { headers: httpTools.getHeader() })
                .then(res => {
                    defer.resolve(res.data.items);
                })
                .catch(error => {
                    console.error(error);
                    defer.reject(error);
                });
            return defer.promise;
        },
        getRegions: countryCode => {
            let defer = Q.defer();
            axios
                .get(`${baseUrl}/countries/` + countryCode + `/regions`, { headers: httpTools.getHeader() })
                .then(res => {
                    defer.resolve(res.data.items);
                })
                .catch(error => {
                    console.error(error);
                    defer.reject(error);
                });
            return defer.promise;
        },
        getShippingMethods: countryCode => {
            let defer = Q.defer();
            axios
                .get(`${baseUrl}/shippingmethods.js?destination=` + countryCode + `&market=` + countryCode, {
                    headers: httpTools.getHeader()
                })
                .then(res => {
                    defer.resolve(res.data.data);
                })
                .catch(error => {
                    console.error(error);
                    defer.reject(error);
                });
            return defer.promise;
        },
        validateAddress: address => {
            //https://hydra.unicity.net/v5/addresses?country=US&address1=1201%20N%20800%20E&address2=&city=OREM&state=UT&zip_code=84097
            let defer = Q.defer();
            axios
                .get(
                    `${baseUrl}/addresses?country=${address.country}&address1=${address.address1}&address2=${address.address2}&city=${address.city}&state=${address.state}&zip_code=${address.zip}`,
                    { headers: httpTools.getHeader() }
                )
                .then(result => {
                    defer.resolve(result);
                })
                .catch(error => {
                    console.error(error);
                    defer.reject(error);
                });
            return defer.promise;
        },
        getCountryRegions: address => {
            let defer = Q.defer();
            axios
                .get(`${baseUrl}/addresses?country=${address.country}&zip=${address.zip}`, {
                    headers: httpTools.getHeader()
                })
                .then(res => {
                    defer.resolve(res.data.items);
                })
                .catch(error => {
                    console.error(error);
                    defer.reject(error);
                });
            return defer.promise;
        }
    };
})();

export default Countries;



// WEBPACK FOOTER //
// ./src/services/http/countries.js